import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';

import BMIFloat from './components/BMIFloat';
// Simple campaign popup - no backend dependency
import SimpleConsultationPopup from './components/SimpleConsultationPopup';
import ErrorBoundary from './components/ErrorBoundary';

import BackToTop from './components/BackToTop';
import ScrollToTop from './components/ScrollToTop';
import HashNavigationHandler from './components/HashNavigationHandler';
import DynamicFooter from './components/DynamicFooter';

import Home from './pages/Home';
import Services from './pages/Services';
import DiseaseManagement from './pages/DiseaseManagement';
import Transformations from './pages/Transformations';
import Recipes from './pages/Recipes';
import About from './pages/About';
import Contact from './pages/Contact';
import Blog from './pages/Blog';
import BlogPost from './pages/BlogPost';

// Admin components
import AdminLogin from './pages/admin/AdminLogin';
import AdminLayout from './components/admin/AdminLayout';
import AdminDashboard from './pages/admin/AdminDashboard';
import AdminRecipes from './pages/admin/AdminRecipes';
import AdminConsultations from './pages/admin/AdminConsultations';
import AdminCampaigns from './pages/admin/AdminCampaigns';
import AdminTransformations from './pages/admin/AdminTransformations';
import AdminReviews from './pages/admin/AdminReviews';
import AdminContacts from './pages/admin/AdminContacts';
import AdminBlogs from './pages/admin/AdminBlogs';
import AdminBlogForm from './pages/admin/AdminBlogForm';

function App() {
  return (
    <ErrorBoundary>
      <Router>
        <div className="App min-h-screen bg-neutral-25 overflow-x-hidden" style={{
          maxWidth: 'none', 
          width: '100%', 
          margin: 0, 
          padding: 0,
          boxSizing: 'border-box'
        }}>
          <Routes>
            {/* Admin Routes */}
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin" element={<AdminLayout />}>
              <Route path="dashboard" element={<AdminDashboard />} />
              <Route path="consultations" element={<AdminConsultations />} />
              <Route path="blogs" element={<AdminBlogs />} />
              <Route path="blogs/new" element={<AdminBlogForm />} />
              <Route path="blogs/:id/edit" element={<AdminBlogForm />} />
              <Route path="transformations" element={<AdminTransformations />} />
              <Route path="reviews" element={<AdminReviews />} />
              <Route path="contacts" element={<AdminContacts />} />
              <Route path="recipes" element={<AdminRecipes />} />
              <Route path="campaigns" element={<AdminCampaigns />} />
            </Route>
            
            {/* Public Routes */}
            <Route path="/*" element={
              <>
                <ScrollToTop />
                <HashNavigationHandler />
                <Navbar />
                <main>
                  <Routes>
                    <Route path="/" element={<Home />} />
                    <Route path="/services" element={<Services />} />
                    <Route path="/disease-management" element={<DiseaseManagement />} />
                    <Route path="/transformations" element={<Transformations />} />
                    <Route path="/recipes" element={<Recipes />} />
                    <Route path="/blog" element={<Blog />} />
                    <Route path="/blog/:id" element={<BlogPost />} />
                    <Route path="/about" element={<About />} />
                    <Route path="/contact" element={<Contact />} />
                  </Routes>
                </main>
                <Footer />
                <BMIFloat />
                <DynamicFooter />
                <BackToTop />

                {/* Simple Campaign Popup - No backend dependency */}
                <SimpleConsultationPopup />

              </>
            } />
          </Routes>
        </div>
      </Router>
    </ErrorBoundary>
  );
}

export default App;